import {
    CustomerLandingPageRelayQuery,
    getCustomerLandingPageRelayQueryVars
} from "src/contentful/graphql/customer-landing-page";

import { init as initRelay } from "../init-relay";
import { CustomersLandingPage } from "../pages/customers/customers-landing-page";
const relayApi = "contentful";

initRelay(
    CustomersLandingPage,
    CustomerLandingPageRelayQuery,
    getCustomerLandingPageRelayQueryVars(window.location),
    relayApi
);
